// extracted by extract-css-chunks-webpack-plugin
module.exports = {"timeline-countdown":"styles__timeline-countdown___oNd_t","timelineCountdown":"styles__timeline-countdown___oNd_t","date":"styles__date___1rvV2","details-link":"styles__details-link___1lhFO","detailsLink":"styles__details-link___1lhFO","pencil-icon":"styles__pencil-icon___3x7Oy","pencilIcon":"styles__pencil-icon___3x7Oy"};
    if(module.hot) {
      // 1773710388571
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  